type ObjectWithTypename = {
  __typename: string;
};

export function removeTypenameFromArray<T extends ObjectWithTypename>(
  items: T[]
) {
  return items.map(item => {
    const { __typename, ...rest } = item;
    return {
      ...rest,
    };
  });
}

export function removeTypenameFromObject<T extends ObjectWithTypename>(
  item: T
) {
  const { __typename, ...rest } = item;
  return {
    ...rest,
  };
}

interface AnyObjectWithTypename {
  __typename?: string;
  [key: string]: any;
}

export function removeTypename<T extends AnyObjectWithTypename>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map(removeTypename) as unknown as T;
  } else if (obj !== null && typeof obj === 'object') {
    const newObj = {} as T;
    Object.keys(obj).forEach(key => {
      if (key !== '__typename') {
        // Recursively call removeTypename for nested objects/arrays
        newObj[key as keyof T] = removeTypename(obj[key]);
      }
    });
    return newObj;
  }
  return obj;
}
